module.exports = __webpack_public_path__ + "media/images/resell-unselect-e7803748ab517e4ba6c93ff585d278c1.png";